import { render, staticRenderFns } from "./UsersConfig.vue?vue&type=template&id=f7c6aeb0&scoped=true"
import script from "./UsersConfig.vue?vue&type=script&lang=js"
export * from "./UsersConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c6aeb0",
  null
  
)

export default component.exports